import { __exports as MSI10 } from "./index209.js";
import { __require as requireMSI } from "./index175.js";
import { __require as requireChecksums } from "./index210.js";
var hasRequiredMSI10;
function requireMSI10() {
  if (hasRequiredMSI10) return MSI10;
  hasRequiredMSI10 = 1;
  Object.defineProperty(MSI10, "__esModule", {
    value: true
  });
  var _MSI2 = requireMSI();
  var _MSI3 = _interopRequireDefault(_MSI2);
  var _checksums = requireChecksums();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI10$1 = (function(_MSI) {
    _inherits(MSI102, _MSI);
    function MSI102(data, options) {
      _classCallCheck(this, MSI102);
      return _possibleConstructorReturn(this, (MSI102.__proto__ || Object.getPrototypeOf(MSI102)).call(this, data + (0, _checksums.mod10)(data), options));
    }
    return MSI102;
  })(_MSI3.default);
  MSI10.default = MSI10$1;
  return MSI10;
}
export {
  requireMSI10 as __require
};
//# sourceMappingURL=index176.js.map
